import { Payload, StringMap } from "@/app/types";
import { ZodError } from "zod";
import Cookies from "js-cookie";
import jwt, { JwtPayload } from "jsonwebtoken";
import { NextApiRequest, NextApiResponse } from "next";
import { NextRequest, NextResponse } from "next/server";

// DEPRECATED: Use JWT_SECRET from environment variables instead
// This is kept for backward compatibility but should not be used for new code
export const SECRET = process.env.JWT_SECRET || "%*f98h498t09IJ089HRI8N34098RJ0ZJ)**90JFF";

export const convertZodErrors = (error: ZodError): StringMap => {
	return error.issues.reduce((acc: { [key: string]: string }, issue) => {
		acc[issue.path[0]] = issue.message;
		return acc;
	}, {});
};

export function getAuthorizationHeader(providedToken?: string) {
	// If a token is provided directly, use it (highest priority)
	if (providedToken && providedToken !== "undefined" && providedToken.trim() !== "") {
		return {
			Authorization: `Bearer ${providedToken}`,
		};
	}

	// Fall back to reading from cookie
	let currentUserCookies = Cookies.get("mygeotokens_user");
	let currentUser: any = {};

	if (currentUserCookies) {
		try {
			currentUser = JSON.parse(currentUserCookies);
		} catch {
			try {
				const decodedValue = decodeURIComponent(currentUserCookies);
				currentUser = JSON.parse(decodedValue);
			} catch (e) {
				console.error("[CLIENT AUTH] Failed to parse user cookie:", e);
			}
		}
	}

	// Check for both accessToken (legacy) and token (Privy auth)
	const token = currentUser?.accessToken || currentUser?.token;

	// Only return Authorization header if we have a valid token
	if (token && token !== "undefined" && token.trim() !== "") {
		return {
			Authorization: `Bearer ${token}`,
		};
	}

	// Return empty object if no valid token is available
	console.warn("[CLIENT AUTH] No valid token found, returning empty headers");
	return {};
}

export const generateAccessToken = (payload: Payload): string => {
	const JWT_SECRET = process.env.JWT_SECRET || SECRET;
	return jwt.sign(payload, JWT_SECRET, { expiresIn: "24h" });
};

export function generateOTP(length: number): string {
	const min = Math.pow(10, length - 1);
	const max = Math.pow(10, length) - 1;
	return Math.floor(min + Math.random() * (max - min + 1)).toString();
}
